import type { RouteRecordRaw, RouteComponent } from 'vue-router'
import { PageTypes } from '@core/constants/pages'
import { REVIEW } from '@gifsa/language-utils/routes'

export function getReviewRoutes(component: RouteComponent): RouteRecordRaw[] {
  return REVIEW.map(
    ({ url, lang }): RouteRecordRaw => ({
      name: `review-${lang}`,
      path: joinRoute(url, ':provider'),
      meta: { pageType: PageTypes.REVIEW, lang },
      component,
    }),
  )
}
